<template>
  <div class="progress-circular-wrapper">
    <v-progress-circular
      v-show="time > 0"
      :width="4"
      :rotate="-90"
      v-model="timeValue"
      :class="contdownClasses"
      class="rounded-circle"
    >
      {{ timeLeft >= 0 ? timeLeft : 0 }}
    </v-progress-circular>
  </div>
</template>

<script>
import db from "../../js/db";
export default {
  name: "progress-countdown",
  props: {
    name: {
      type: String,
    },
    time: {
      type: Number,
      default: 25,
    },
  },
  data() {
    return {
      timeLeft: 0,
      running: false,
      timer: null,
    };
  },
  methods: {
    next() {
      if (this.running) {
        if (this.timeLeft > 0) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.timeLeft = this.timeLeft - 1;
            this.next();
          }, 1000);
          localStorage.setItem("ls_time_" + this.name, this.timeLeft);
          this.$emit("timeStep", this.timeLeft);
        } else {
          this.$emit("timeStep", 0);
          this.$emit("timeover");
        }
      }
    },
    // next() {
    //   if (this.running) {
    //     if (this.timeLeft > 0) {
    //       clearTimeout(this.timer);
    //       this.timer = setTimeout(
    //         function () {
    //           this.timeLeft = this.timeLeft - 1;
    //           this.next();
    //         }.bind(this),
    //         1000
    //       );
    //       localStorage.setItem("ls_time_" + this.name, this.timeLeft);
    //     } else {
    //       this.$emit("timeover");
    //     }
    //   }
    // },

    start() {
      if (this.time > 0) {
        this.running = true;
        this.timeLeft =
          localStorage.getItem("ls_time_" + this.name) || this.time;
        this.next();
      }
    },
    stop() {
      this.clean();
    },
    updateTimer(tl) {
      clearTimeout(this.timer);
      this.timeLeft = tl;
      this.next();
    },
    clean() {
      this.running = false;
      localStorage.removeItem("ls_time_" + this.name);
      clearTimeout(this.timer);
    },
  },
  mounted() {
    this.pb_cont = $(this.$el);
    this.pb = this.pb_cont.find(".bar");
  },
  beforeDestroy() {
    this.clean();
  },

  computed: {
    timeValue: function () {
      return (this.timeLeft / this.time) * 100;
    },
    contdownClasses: function () {
      return {
        "white red--text": this.timeLeft < 10,
        "white--text": this.timeLeft >= 10,
      };
    },
  },
};
</script>

<style lang="scss">
.progress-circular-wrapper {
  background: rgb(0 0 0 / 12%);
  padding: 5px;
  border-radius: 50%;
  height: 42px;
  width: 42px;
  font-size: 11px;
  box-shadow: 0 0 0 0 #607d8b;
  animation: pulsante 1.25s infinite;
}
</style>
